import { render, staticRenderFns } from "./SwitchColor.vue?vue&type=template&id=edf503e6"
import script from "./SwitchColor.vue?vue&type=script&lang=ts"
export * from "./SwitchColor.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports